import { OptionWithText } from "../../orcadent/models/questionnaire-orcadent.model";

/**
 * Represents the version of the 'MichiganSplintQuestionnaireModel'
 * - should be incremented with every change
 */
export const MichiganSplintQuestionnaireModelVersion = 0;
export interface MichiganSplintQuestionnaireModel {
	verticalDimension: OptionWithText;
	individualComments?: string;
	version: number;
}


export enum MichiganSplintQuestionnaireSection {
    VERTICAL_DIMENSION = "VerticalDimension",
    INDIVIDUAL_COMMENTS = "IndividualComments",
}

export interface MichiganSplintQuestionnaireSectionData {
	headline: string;
	helpText?: { de: string; en: string };
}

export enum VerticalDimensionAnswerOption{
	NO_ADJUSTMENT = "noAdjustment",
	IF_NECESSARY = "ifNecessary",
	ADJUST_BY_MM = "adjustByMM",
}


export const MichiganSplintQuestionnaireDataRecord: Record<MichiganSplintQuestionnaireSection,MichiganSplintQuestionnaireSectionData> = {
	[MichiganSplintQuestionnaireSection.VERTICAL_DIMENSION]: {
		headline: "VerticalDimensionHeader",
	},
	[MichiganSplintQuestionnaireSection.INDIVIDUAL_COMMENTS]: {
		headline: "IndividualCommentsHeader"
	},
}
